import {Component, forwardRef, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {cloneDeep} from "lodash-es";
import {NzUploadFile, NzUploadModule} from "ng-zorro-antd/upload";
import {NzMessageService} from "ng-zorro-antd/message";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzIconModule} from "ng-zorro-antd/icon";
import {NzTableModule} from "ng-zorro-antd/table";
import {NzPipesModule} from "ng-zorro-antd/pipes";
import {NzPopconfirmModule} from "ng-zorro-antd/popconfirm";
import {NzDividerModule} from "ng-zorro-antd/divider";
import {NzFormModule} from "ng-zorro-antd/form";
import {FileListComponent} from "./file-list.component";
import {AimsFile} from '../model';


@Component({
  selector: 'app-upload',
  standalone: true,
  imports: [CommonModule, NzUploadModule, NzButtonModule, NzIconModule, NzTableModule, NzPipesModule, NzPopconfirmModule, NzDividerModule, NzFormModule, FileListComponent],
  template: `
    <nz-form-label [nzRequired]="mandatory">
      <label *ngIf="uploadDesc">{{uploadDesc}}</label>
    </nz-form-label>
    <nz-upload [nzBeforeUpload]="beforeUpload" [nzAccept]="accept">
      <button nz-button type="button" [disabled]="disableUpload">
        <span nz-icon nzType="upload"></span>
        Click to Upload
      </button>
    </nz-upload>
    <app-file-list [fileList]="fileList" (updateFileList)="onChanged($event)"
                   [viewMode]="disableUpload"></app-file-list>
  `,
  styles: [
    `
      button:nth-child(n+1) {
        margin-left: 5px;
      }

    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UploadComponent),
      multi: true
    }
  ]
})
export class UploadComponent implements ControlValueAccessor {
  @Input() uploadDesc = '';
  @Input() accept = '*/*';
  @Input() max?: number | undefined = 1024 * 1024;
  @Input() mandatory = false;
  @Input() disableUpload = false;

  fileList: AimsFile[] = [];


  constructor(private message: NzMessageService) {
  }

  onChanged: any = (_: any) => {
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.disableUpload = isDisabled;
  }

  writeValue(obj: any): void {
    const val = cloneDeep(obj) || [];
    if (!Array.isArray(val)) {
      throw new Error('File list only support Array');
    }
    this.fileList = val;
    // not show deleted files
    // this.fileList = val.filter(f => !f.deleted);
  }


  beforeUpload = (file: NzUploadFile): boolean => {
    if (file.size && file.size > this.max!) {
      this.message.warning(`File size (${file.size}) exceeds the limit (${this.max}).`);
      return false;
    }


    this.fileList.push({
      name: file.name,
      size: file.size!,
      type: file.type!,
      _raw: (file as any),
      uploadStatus: 'pending'
    });
    this.onChanged(this.fileList);
    return false;
  }

}
